import { BaseListener } from "./base-listener";
export class DBLatestGroupIdListener extends BaseListener {
    constructor(db) {
        super("DBLatestGroupIdListener");
        Object.defineProperty(this, "db", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "latestGroupIdRef", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "handleLatestGroupIdRef", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (snapshot) => {
                const val = snapshot.val() || undefined;
                this.debugLogSnapshot("#handleLatestGroupIdRef", snapshot);
                this.db.stores.user.setLatestGroupId(val);
            }
        });
        this.db = db;
    }
    start() {
        return new Promise((resolve, reject) => {
            const latestGroupIdRef = this.latestGroupIdRef = this.db.firebase.getLatestGroupIdRef();
            // use once() so we are ensured that latestGroupId is set before we resolve
            this.debugLogHandler("#start", "adding", "once", latestGroupIdRef);
            latestGroupIdRef.once("value")
                .then(snapshot => {
                this.handleLatestGroupIdRef(snapshot);
                this.debugLogHandler("#start", "adding", "on value", latestGroupIdRef);
                latestGroupIdRef.on("value", this.handleLatestGroupIdRef);
                resolve();
            })
                .catch(reject);
        });
    }
    stop() {
        if (this.latestGroupIdRef) {
            this.debugLogHandler("#stop", "removing", "on value", this.latestGroupIdRef);
            this.latestGroupIdRef.off("value");
            this.latestGroupIdRef = null;
        }
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGItbGF0ZXN0LWdyb3VwLWlkLWxpc3RlbmVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2xpYi9kYi1saXN0ZW5lcnMvZGItbGF0ZXN0LWdyb3VwLWlkLWxpc3RlbmVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBLE9BQU8sRUFBRSxZQUFZLEVBQUUsTUFBTSxpQkFBaUIsQ0FBQztBQUUvQyxNQUFNLE9BQU8sdUJBQXdCLFNBQVEsWUFBWTtJQUl2RCxZQUFZLEVBQU07UUFDaEIsS0FBSyxDQUFDLHlCQUF5QixDQUFDLENBQUM7UUFKM0I7Ozs7O1dBQU87UUFDUDs7OzttQkFBdUQsSUFBSTtXQUFDO1FBK0I1RDs7OzttQkFBeUIsQ0FBQyxRQUF3QyxFQUFFLEVBQUU7Z0JBQzVFLE1BQU0sR0FBRyxHQUFHLFFBQVEsQ0FBQyxHQUFHLEVBQUUsSUFBSSxTQUFTLENBQUM7Z0JBQ3hDLElBQUksQ0FBQyxnQkFBZ0IsQ0FBQyx5QkFBeUIsRUFBRSxRQUFRLENBQUMsQ0FBQztnQkFDM0QsSUFBSSxDQUFDLEVBQUUsQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUFDLGdCQUFnQixDQUFDLEdBQUcsQ0FBQyxDQUFDO1lBQzVDLENBQUM7V0FBQztRQS9CQSxJQUFJLENBQUMsRUFBRSxHQUFHLEVBQUUsQ0FBQztJQUNmLENBQUM7SUFFTSxLQUFLO1FBQ1YsT0FBTyxJQUFJLE9BQU8sQ0FBTyxDQUFDLE9BQU8sRUFBRSxNQUFNLEVBQUUsRUFBRTtZQUMzQyxNQUFNLGdCQUFnQixHQUFHLElBQUksQ0FBQyxnQkFBZ0IsR0FBRyxJQUFJLENBQUMsRUFBRSxDQUFDLFFBQVEsQ0FBQyxtQkFBbUIsRUFBRSxDQUFDO1lBQ3hGLDJFQUEyRTtZQUMzRSxJQUFJLENBQUMsZUFBZSxDQUFDLFFBQVEsRUFBRSxRQUFRLEVBQUUsTUFBTSxFQUFFLGdCQUFnQixDQUFDLENBQUM7WUFDbkUsZ0JBQWdCLENBQUMsSUFBSSxDQUFDLE9BQU8sQ0FBQztpQkFDM0IsSUFBSSxDQUFDLFFBQVEsQ0FBQyxFQUFFO2dCQUNmLElBQUksQ0FBQyxzQkFBc0IsQ0FBQyxRQUFRLENBQUMsQ0FBQztnQkFDdEMsSUFBSSxDQUFDLGVBQWUsQ0FBQyxRQUFRLEVBQUUsUUFBUSxFQUFFLFVBQVUsRUFBRSxnQkFBZ0IsQ0FBQyxDQUFDO2dCQUN2RSxnQkFBZ0IsQ0FBQyxFQUFFLENBQUMsT0FBTyxFQUFFLElBQUksQ0FBQyxzQkFBc0IsQ0FBQyxDQUFDO2dCQUMxRCxPQUFPLEVBQUUsQ0FBQztZQUNaLENBQUMsQ0FBQztpQkFDRCxLQUFLLENBQUMsTUFBTSxDQUFDLENBQUM7UUFDbkIsQ0FBQyxDQUFDLENBQUM7SUFDTCxDQUFDO0lBRU0sSUFBSTtRQUNULElBQUksSUFBSSxDQUFDLGdCQUFnQixFQUFFLENBQUM7WUFDMUIsSUFBSSxDQUFDLGVBQWUsQ0FBQyxPQUFPLEVBQUUsVUFBVSxFQUFFLFVBQVUsRUFBRSxJQUFJLENBQUMsZ0JBQWdCLENBQUMsQ0FBQztZQUM3RSxJQUFJLENBQUMsZ0JBQWdCLENBQUMsR0FBRyxDQUFDLE9BQU8sQ0FBQyxDQUFDO1lBQ25DLElBQUksQ0FBQyxnQkFBZ0IsR0FBRyxJQUFJLENBQUM7UUFDL0IsQ0FBQztJQUNILENBQUM7Q0FPRiJ9